<template>
  <div class="mask" @click.self="close">
    <div class="filter">
      <div class="type_filter">
        <div class="kansen_type m">
          <p>艦種</p>
        </div>
        <ul>
          <li
            @click="filtertype('駆逐')"
            :style="[
              filter.includes('駆逐')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            駆逐
          </li>
          <li
            @click="filtertype('軽巡')"
            :style="[
              filter.includes('軽巡')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            軽巡
          </li>
          <li
            @click="filtertype('重巡')"
            :style="[
              filter.includes('重巡')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            重巡
          </li>
          <li
            @click="filtertype('巡戦')"
            :style="[
              filter.includes('巡戦')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            巡戦
          </li>
          <li
            @click="filtertype('戦艦')"
            :style="[
              filter.includes('戦艦')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            戦艦
          </li>
          <li
            @click="filtertype('航空戦艦')"
            :style="[
              filter.includes('航空戦艦')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            航空戦艦
          </li>
          <li
            @click="filtertype('砲艦')"
            :style="[
              filter.includes('砲艦')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            砲艦
          </li>
        </ul>
      </div>
      <div class="type_filter">
        <div class="kansen_type m">
          <p>陣営</p>
        </div>
        <ul>
          <li
            @click="filtertype2('ユニオン')"
            :style="[
              filter2.includes('ユニオン')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            ユニオン
          </li>
          <li
            @click="filtertype2('ロイヤル')"
            :style="[
              filter2.includes('ロイヤル')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            ロイヤル
          </li>
          <li
            @click="filtertype2('重桜')"
            :style="[
              filter2.includes('重桜')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            重桜
          </li>
          <li
            @click="filtertype2('鉄血')"
            :style="[
              filter2.includes('鉄血')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            鉄血
          </li>
          <li
            @click="filtertype2('東煌')"
            :style="[
              filter2.includes('東煌')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            東煌
          </li>
          <li
            @click="filtertype2('サディア')"
            :style="[
              filter2.includes('サディア')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            サディア
          </li>
          <li
            @click="filtertype2('北方連合')"
            :style="[
              filter2.includes('北方連合')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            北方連合
          </li>
          <li
            @click="filtertype2('アイリス')"
            :style="[
              filter2.includes('アイリス')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            アイリス
          </li>
          <li
            @click="filtertype2('ヴィシア')"
            :style="[
              filter2.includes('ヴィシア')
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            ヴィシア
          </li>
          <li
            @click="filtertype2('その他')"
            :style="[
              other_switch
                ? {
                    background:
                      'linear-gradient(to bottom, rgba(200,200,200,0.3) 0%,rgba(248,184,98,0.5) 45%)',
                  }
                : {
                    'background-color': 'rgba(150, 150, 150, 0.5)',
                  },
            ]"
          >
            その他
          </li>
        </ul>
      </div>
    </div>
    <div class="charalist">
      <ul>
        <li
          v-for="(value, index) in chosen"
          :key="value.Name"
          :style="{
            'background-image':
              'url(\'/static/img/bg/' + 'C' + value.Rarity + '.png\')',
          }"
          :title="value.Name"
          @click="setdata(index)"
        >
          <img :src="'/static/img/strip/' + value.Name + '.png'" />
          <p>{{ value.Name }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "List",
  data() {
    return {
      character_list: [],
      chosen: [],
      filter: [],
      filter2: [],
      other: [
        "全般",
        "ネプチュニア",
        "うたわれるもの",
        "キズナアイ",
        "ホロライブ",
        "ヴィーナスバケーション",
        "アイドルマスター",
      ],
      other_switch: false,
    };
  },
  mounted: function () {
    this.axios
      .get("data.json")
      .then((response) => {
        this.character_list.splice(0, this.character_list.length);
        for (let i = 0; i < response.data.Character_list.length; i++) {
          this.character_list.push(response.data.Character_list[i]);
        }

        this.character_list.sort(function (x, y) {
          if (x.Rarity < y.Rarity) {
            return 1;
          }
          if (x.Rarity > y.Rarity) {
            return -1;
          }
          if (x.Type < y.Type) {
            return 1;
          }
          if (x.Type > y.Type) {
            return -1;
          }
          if (x.Name > y.Name) {
            return 1;
          }
          if (x.Name < y.Name) {
            return -1;
          }
        });
        this.filtered();
      })
      .catch((e) => {
        alert(e);
      });
  },
  methods: {
    setdata: function (index) {
      this.$emit("selected", this.chosen[index]);
    },
    close: function () {
      this.$emit("close");
    },
    filtertype: function (data) {
      if (this.filter.includes(data)) {
        this.filter.splice(this.filter.indexOf(data), 1);
      } else {
        this.filter.push(data);
      }
      this.filtered();
    },
    filtertype2: function (data) {
      if (data == "その他") {
        if (!this.other_switch) {
          this.filter2 = this.filter2.concat(this.other);
          this.other_switch = true;
        } else {
          for (let i = 0; i < this.other.length; i++) {
            this.filter2.splice(this.filter2.indexOf(this.other[i]), 1);
          }
          this.other_switch = false;
        }
      } else if (this.filter2.includes(data)) {
        this.filter2.splice(this.filter2.indexOf(data), 1);
      } else {
        this.filter2.push(data);
      }
      this.filtered();
    },
    filtered: function () {
      let filter = this.filter;
      let filter2 = this.filter2;
      this.chosen.splice(0, this.chosen);
      if (this.filter.length < 1 && this.filter2.length < 1) {
        Object.assign(this.chosen, this.character_list);
      } else {
        this.chosen = this.character_list.filter(function (item) {
          if (filter.length > 0 && filter2.length > 0) {
            for (let i = 0; i < filter.length; i++) {
              for (let x = 0; x < filter2.length; x++) {
                if (item.Type == filter[i] && item.Affiliation == filter2[x]) {
                  return true;
                }
              }
            }
          } else if (filter.length > 0 && filter2.length < 1) {
            for (let i = 0; i < filter.length; i++) {
              if (item.Type == filter[i]) {
                return true;
              }
            }
          } else if (filter.length < 1 && filter2.length > 0) {
            for (let x = 0; x < filter2.length; x++) {
              if (item.Affiliation == filter2[x]) {
                return true;
              }
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mask {
  width: 100%;
  height: 100%;
  background: rgba(150, 150, 150, 0.5);
  position: absolute;
  top: 0;
  left: 0;
}
.charalist {
  position: relative;
  margin: 0 auto;
  background: rgba(50, 50, 50, 0.8);
  width: 90%;
  max-width: 720px;
  max-height: 75%;
  overflow-y: overlay;
  padding: 5px 0 5px 0;
  border-width: 0 0.5px 0.5px 0.5px;
  border-color: #f0f0f0;
  border-style: solid;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      $margin: 0.25%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: (100% - $margin * 16) / 8;
      color: #f0f0f0;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      border-radius: 6px;
      margin: 5px $margin 0 $margin;
      &::before {
        content: "";
        display: block;
        padding-top: 133%;
      }
      &:hover p {
        background: rgba(230, 230, 230, 1);
        color: #000;
      }
      img {
        width: 95%;
        height: auto;
      }
      p {
        padding: 2px 1px;
        position: absolute;
        transition: 0.5s;
        bottom: 5%;
        width: 100%;
        text-align: center;
        font-size: 70%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        background: rgba(50, 50, 50, 0.8);
      }
    }
  }
}
.filter {
  width: 90%;
  border-width: 0.5px 0.5px 0.5px 0.5px;
  border-color: #f0f0f0;
  border-style: solid;
  max-width: 720px;
  margin: 2.5% auto 0 auto;
  background: rgba(50, 50, 50, 0.8);
  padding: 5px 10px 5px 10px;

  .type_filter {
    display: flex;
    width: 100%;
    .kansen_type {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      padding: 5px 0 5px 0;
      font-size: 130%;
      color: #f0f0f0;
      border: solid 0.5px #f0f0f0;
      background: rgba(80, 130, 180, 0.8);
    }
  }
  .type_filter:nth-of-type(2) {
    margin-top: 5px;
  }
  ul {
    display: flex;
    width: 85%;
    align-items: center;
    flex-wrap: wrap;
    li {
      cursor: pointer;
      transition: 0.1s;
      box-shadow: 4px 4px 1px #333;
      color: #f0f0f0;
      background: rgba(150, 150, 150, 0.5);
      font-size: 90%;
      margin: 3px 1% 3px 1%;
      padding: 3px 0 3px 0;
      width: 18%;
      border: solid 0.5px #f0f0f0;
      border-collapse: collapse;
    }
  }
}
@media screen and (max-width: 450px) {
  .filter {
    width: 100%;
    padding: 5px 3px 5px 3px;
    ul {
      li {
        margin: 3px 1% 3px 1%;
        width: 23%;
        font-size: 85%;
      }
    }
  }
  .charalist {
    width: 100%;
    max-height: 65%;
    ul {
      li {
        width: 19%;
        margin: 5px 0.5% 5px 0.5%;
      }
    }
  }
}
</style>